<template>
    <el-dialog
        title="订单详情"
        :visible.sync="dialogVisible"
        width="90%"
        :close-on-click-modal="false"
        @close="handleClose"
    >
        <el-table
            :data="orderTableData"
            border
            stripe
            max-height="500"
            v-loading="loading"
            style="width: 100%"
        >
            <el-table-column type="index" width="45" label="#" fixed/>
            <el-table-column prop="orderNo" label="订单号" :show-overflow-tooltip="true" min-width="140" fixed/>
            <el-table-column prop="distributorName" label="经销商" :show-overflow-tooltip="true" min-width="180"/>
            <el-table-column prop="productName" label="商品名称" :show-overflow-tooltip="true" min-width="160"/>
            <el-table-column prop="isCountSales" label="是否计入销额" width="120">
                <template slot-scope="scope">{{ scope.row.isCountSales | dictname('xiaoe_jishu') }}</template>
            </el-table-column>
            <el-table-column prop="isCountBase" label="是否计入基数" width="120">
                <template slot-scope="scope">{{ scope.row.isCountBase | dictname('xiaoe_jishu') }}</template>
            </el-table-column>
            <el-table-column prop="signChain" label="签约链群" :show-overflow-tooltip="true" min-width="100">
                <template slot-scope="scope">{{ scope.row.signChain | dictname('xsyb_lianqun') }}</template>
            </el-table-column>
            <el-table-column prop="rebateIndustry" label="返利归属产业" :show-overflow-tooltip="true" min-width="110">
                <template slot-scope="scope">{{ scope.row.rebateIndustry | dictrefid('xsyb_lianqun') }}</template>
            </el-table-column>
            <el-table-column prop="specModel" label="规格型号" :show-overflow-tooltip="true" min-width="160"/>
            <el-table-column prop="invoiceName" label="开票名称" :show-overflow-tooltip="true" min-width="160"/>
            <el-table-column prop="quantity" label="数量" width="80"/>
            <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" min-width="140"/>
            <el-table-column prop="selfOrOem" label="自产/OEM" width="90"/>
            <!--            <el-table-column prop="sharedCategory" label="共享大类" :show-overflow-tooltip="true" min-width="120"/>-->
            <el-table-column prop="isDistributorOrder" label="是否分销商订单" width="120">
                <template slot-scope="scope">{{ scope.row.isDistributorOrder | dictname('shifou_keyong') }}</template>
            </el-table-column>
            <el-table-column prop="distributorName2" label="分销商名称" :show-overflow-tooltip="true" min-width="160"/>
            <el-table-column prop="productCode" label="商品编码" :show-overflow-tooltip="true" min-width="120"/>
            <el-table-column prop="distributorOrderNo" label="分销商订单号" :show-overflow-tooltip="true"
                             min-width="140"/>
            <el-table-column prop="orderStatus" label="订单状态" width="100">
                <template slot-scope="scope">{{ scope.row.orderStatus | dictname('order_status') }}</template>
            </el-table-column>
            <el-table-column prop="orderType" label="订单类型" width="100">
                <template slot-scope="scope">{{ scope.row.orderType | dictname('xiaoshou_quyu') }}
                    {{ scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                </template>
            </el-table-column>
            <el-table-column prop="salesOrg" label="销售组织" :show-overflow-tooltip="true" min-width="120">
                <template slot-scope="scope">{{ scope.row.salesOrg | dictname('YLSalesOrganization_agent') }}</template>
            </el-table-column>
            <el-table-column prop="factory" label="工厂" :show-overflow-tooltip="true" min-width="100"/>
            <el-table-column prop="dnNo" label="DN单号" :show-overflow-tooltip="true" min-width="120"/>
            <el-table-column prop="soNo" label="SO单号" :show-overflow-tooltip="true" min-width="120"/>
            <el-table-column prop="creditCheckStatus" label="信用检查状态" width="110">
                <template slot-scope="scope">{{
                        scope.row.creditCheckStatus | dictname('xinyong_zhuangtai')
                    }}
                </template>
            </el-table-column>
            <el-table-column prop="distributorType" label="经销商类型" :show-overflow-tooltip="true" min-width="120">
                <template slot-scope="scope">{{ scope.row.distributorType | dictname('dailishang_leixing') }}</template>
            </el-table-column>
            <el-table-column prop="distributorCode" label="经销商编码" :show-overflow-tooltip="true" min-width="120"/>
            <el-table-column prop="logisticsName" label="物流名称" :show-overflow-tooltip="true" min-width="140"/>
            <el-table-column prop="logisticsNo" label="物流单号" :show-overflow-tooltip="true" min-width="140"/>
        </el-table>
    </el-dialog>
</template>

<script>
import http from '../../utils/fetch'

export default {
    name: 'orderDetailDlg',
    props: {
        specialId: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            orderTableData: [],
            loading: false
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        }
    },
    watch: {
        visible(val) {
            if (val && this.specialId) {
                this.loadOrderList()
            }
        }
    },
    methods: {
        async loadOrderList() {
            this.loading = true
            try {
                const res = await http({
                    url: '/api/swyl/v1/lk/special/getOrderListBySpecialId',
                    method: 'post',
                    params: {specialId: this.specialId}
                })
                if (res && res.obj) {
                    this.orderTableData = res.obj
                }
            } catch (e) {
                console.error('获取订单详情失败', e)
                this.orderTableData = []
            } finally {
                this.loading = false
            }
        },
        handleClose() {
            this.orderTableData = []
        }
    }
}
</script>

<style>
</style>
